module.exports = __webpack_public_path__ + "img/vidcall.c7afeecd.svg";